import React from "react"
import {FieldManagementPreviewProps} from "../../../../../render/management-preview";


export default function FieldTimeOfDay_ManagementPreview(props: FieldManagementPreviewProps) {

    const value = props.field.getDisplayValue(moment())

    return (
        <div className={Classes("ui5-txt-default", "fl-ac")}>
            <span className="txt-truncate">{props.field.getDisplayValue(value)}</span>
        </div>
    )

}
